// extracted by mini-css-extract-plugin
export var introContainer = "home-module--introContainer--tjvYV";
export var introBlock = "home-module--introBlock--bvjA5";
export var intro = "home-module--intro--m1E4Q";